import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[policy-func]',
    standalone: false
})
export class PolicyFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}